import './style.scss';

import { registerBlockType } from '@wordpress/blocks';

import metadata from './block.json';
import { Edit } from './edit';

// @ts-ignore: metadata is not typed yet.
registerBlockType( metadata.name, {
	/**
	 * @see ./edit.tsx
	 */
	edit: Edit,
} );
